class CollectionPasswordForm extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    const expected = this.dataset.password;
    if (!handle) return;

    const sessionKey = `collection_access_${handle}`;

    if (sessionStorage.getItem(sessionKey) === 'true') {
      window.location.replace(`/collections/${handle}?view=unlocked`);
      return;
    }

    const form = this.querySelector('form');
    const input = this.querySelector('input[type="password"]');
    const error = this.querySelector('[data-error]');
    if (!form || !input || !error) return;

    let errorTimer = null;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (input.value === expected) {
        sessionStorage.setItem(sessionKey, 'true');
        window.location.href = `/collections/${handle}?view=unlocked`;
      } else {
        error.classList.add('is-active');
        input.value = '';
        input.focus();
        if (errorTimer) clearTimeout(errorTimer);
        errorTimer = setTimeout(() => error.classList.remove('is-active'), 3000);
      }
    });
  }
}

if (!customElements.get('collection-password-form')) {
  customElements.define('collection-password-form', CollectionPasswordForm);
}
